import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { CANONICAL_BASE_URL } from '../utils/constants';

/** Normalize path for canonical: no trailing slash except for root (avoids /about vs /about/ duplicates). */
function normalizePath(pathname: string): string {
  if (!pathname || pathname === '/') return '/';
  return pathname.replace(/\/+$/, '') || '/';
}

const CanonicalURL: React.FC = () => {
  const location = useLocation();
  const path = normalizePath(location.pathname);
  const canonicalUrl = path === '/' ? `${CANONICAL_BASE_URL}/` : `${CANONICAL_BASE_URL}${path}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default CanonicalURL;
